import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMonthlySpendingState = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 31,
	height: 16,
	viewBox: "0 0 31 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		opacity: .8,
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M30.4979 0.5L17.7488 13.2492L10.2493 5.74967L0.5 15.4991",
			stroke: "#657900",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M21.5008 0.5H30.5005V9.49943",
			stroke: "#657900",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	})
});
export default SvgMonthlySpendingState;
